import { render } from "./cell_menu_list.vue?vue&type=template&id=5e6a64ed"
import script from "./cell_menu_list.vue?vue&type=script&lang=ts"
export * from "./cell_menu_list.vue?vue&type=script&lang=ts"
script.render = render

export default script